<template>
	<div>
		<loading v-if="loading"></loading>
		<div v-if="display == 'Promo'">
			<div class="box-container">
				<button
					class="box-promo-row"
					v-for="item in items"
					:key="item.id"
					@click="item.type === 'file' ? Download(item) : OpenFolder(item)">
					<div style="white-space: nowrap">
						<div class="box-promo-thumbnail">
							<img :src="GetSrc(item.id)" v-if="item.type === 'file'" />
							<o-icon icon="folder" size="medium" v-if="item.type === 'folder'"></o-icon>
						</div>
					</div>
					<div class="box-promo-filename">
						<div>
							<h4>{{ item.name }}</h4>
						</div>
					</div>
					<div class="box-promo-download">
						<!-- <o-button
							variant="primary"
							class="is-light"
							size="large"
							@click="Download(item)"
							v-if="item.type === 'file'">
							<o-icon  icon="arrow-to-bottom"></o-icon>
						</o-button> -->
						<o-icon v-if="item.type === 'file'" icon="arrow-to-bottom"></o-icon>
						<!-- <o-button
							variant="primary"
							class="is-light"
							size="large"
							@click="OpenFolder(item)"
							v-if="item.type === 'folder'">
							<o-icon icon="folder-open"></o-icon>
						</o-button> -->
						<o-icon v-if="item.type === 'folder'" icon="folder-open"></o-icon>
					</div>
				</button>
			</div>
		</div>

		<div v-if="display == 'Table'" class="box-table">
			<o-table :data="items" :defaultSort="['Id', 'desc']" hoverable @click="OnRowClick">
				<o-table-column field="Id" label="" v-slot="props">
					<div class="box-table-thumbnail">
						<img :src="GetSrc(props.row.id)" v-if="props.row.type === 'file'" />
						<o-icon icon="folder" size="medium" v-if="props.row.type === 'folder'"></o-icon>
					</div>
				</o-table-column>
				<o-table-column field="name" label="File Name" sortable v-slot="props">
					<div class="box-table-row">
						{{ props.row.name }}
					</div>
				</o-table-column>
				<o-table-column field="modified_by.name" label="Last Modified By" sortable v-slot="props">
					{{ props.row.modified_by.name }} on
					{{ moment(props.row.modified_at).format("MM/DD/YYYY h:mm") }}
				</o-table-column>
				<o-table-column field="" label="" v-slot="props">
					<div class="box-table-download">
						<o-button
							variant="primary"
							class="is-light"
							@click="Download(props.row)"
							v-if="props.row.type === 'file'">
							<o-icon icon="arrow-to-bottom"></o-icon>
						</o-button>
						<o-button
							variant="primary"
							class="is-light"
							@click="OpenFolder(props.row)"
							v-if="props.row.type === 'folder'">
							<o-icon icon="folder-open"></o-icon>
						</o-button>
					</div>
				</o-table-column>
			</o-table>
		</div>
	</div>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import boxFilesModal from "@/components/modals/boxFilesModal.vue";

	export default {
		props: {
			folderId: {
				type: String,
				default: "0"
			},
			sort: {
				type: String,
				default: null
			},
			direction: {
				type: [String, Number, Boolean],
				default: null
			},
			limit: {
				type: [String, Number],
				default: null
			},
			display: {
				type: String,
				default: "Promo"
			}
		},
		setup(props, context) {
			const http = inject("$http");
			const moment = inject("$moment");
			const oruga = inject("$oruga");

			const loading = ref(false);

			const items = ref([]);
			// const display = ref();
			const files = computed(() => {
				return items.value.filter((x) => x.type === "file");
			});

			const queryString = computed(() => {
				const direction =
					props.direction === true ||
					props.direction === 1 ||
					props.direction === "true" ||
					props.direction === "1";
				const qs = [
					{ key: "sort", val: props.sort },
					{ key: "direction", val: direction ? "1" : "0" },
					{ key: "limit", val: props.limit }
				]
					.filter((x) => x.val)
					.map((x) => x.key + "=" + x.val);
				if (qs.length > 0) {
					return "?" + qs.join("&");
				} else {
					return "";
				}
			});

			const GetSrc = (itemId) => {
				return process.env.VUE_APP_API + "api/v2/box/thumbnail/" + itemId;
			};

			const GetFolder = async () => {
				try {
					loading.value = true;
					const response = await http.get("/api/v2/box/folder/" + props.folderId + queryString.value);
					items.value = response.data.entries;
					loading.value = false;
				} catch (err) {
					console.error(err);
					loading.value = false;
				}
			};

			const Download = async (row) => {
				try {
					const response = await http.get("/api/v2/box/file/" + row.id + "/download", {
						responseType: "blob"
					});

					const blob = response.data;
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.setAttribute("download", row.name);

					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} catch (err) {
					console.error(err);
				}
			};

			const OpenFolder = (row) => {
				oruga.modal.open({
					props: {
						title: row.name,
						folderId: row.id,
						sort: props.sort,
						direction: props.direction,
						limit: props.limit
					},
					component: boxFilesModal,
					trapFocus: true
				});
			};
			const OnRowClick = (row, index) => {
				row.type === "file" ? Download(row) : OpenFolder(row);
			};

			onMounted(() => {
				GetFolder();
			});

			return {
				moment,
				loading,
				items,
				GetSrc,
				Download,
				OpenFolder,
				OnRowClick
			};
		}
	};
</script>

<style lang="scss" scoped>
	@use "sass:color";
	@use "@/assets/css/globalVars.scss" as *;
	.box-table {
		width: 100%;
	}
	.box-promo-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		//margin: 10px 0;
		border: none;
		border-radius: $radius-small;
		width: 100%;
		background-color: transparent;
		text-align: left;

		&:not(:last-child) {
			margin-bottom: $margin-element-medium;
		}

		&:hover {
			cursor: pointer;
			background-color: $boyden-blue-lighter;

			& .box-promo-download {
				background-color: color.adjust($boyden-blue-lighter, $lightness: 3%);
			}
			& .box-promo-thumbnail {
				background-color: color.adjust($boyden-blue-lighter, $lightness: 3%);
			}
		}
	}
	.box-promo-thumbnail {
		background: $boyden-blue-lighter;
		margin-top: $margin-element-tiny;
		margin-bottom: $margin-element-tiny;
		border-radius: $radius-medium;
		height: pxUnits(60);
		width: pxUnits(60);
		padding: 0;
		margin-right: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.box-promo-filename {
		flex-grow: 2;
		display: flex;
	}

	.box-promo-download {
		border-radius: $radius-small;
		width: pxUnits(40);
		min-width: pxUnits(40);
		height: pxUnits(40);
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: $boyden-blue-lighter;
		color: $boyden-blue;
		font-size: 1.4rem;
	}

	.box-table-row {
		// border: solid 1px #eee;
		// border-radius: 4px;
		// display: flex;
		// justify-content: space-between;
		// padding: 10px;
		// margin: 10px 0;
		& > td {
			padding-top: 12px;
		}
	}
	.box-table-thumbnail {
		height: 35px;
		width: 35px;
		margin-right: -10px;
		& > img {
			border-radius: 2px;
		}
	}

	.box-table-filename {
		flex-grow: 2;
		display: flex;
		align-items: center;
	}
	.box-table-download {
		// height: 100px;
		// width: 50px;
		// display: flex;
		align-items: right;
		justify-content: right;
		float: right;
		background-color: $boyden-blue-lighter;
		color: $boyden-blue;

		&:hover {
			background-color: $boyden-blue-lighter !important;
		}
	}
	.box-table {
		margin-top: 10px;
		margin-bottom: 10px;
		td {
			padding-top: 12px;
		}

		&:hover {
			cursor: pointer;
			background-color: $boyden-blue-lighter;

			& .box-table-download {
				background-color: color.adjust($boyden-blue-lighter, $lightness: 3%);
			}
		}
	}
</style>
